<div class="terms">
  <div class="terms__content">
    <img
      src="assets/img/home/logo-padrao.png"
      alt="Logo pescaprecos"
      class="checkout__logo"
      [routerLink]="['/home']"
    />
    <img
      src="assets/img/home/baleia_azul.png"
      alt="Logo pescaprecos mobile"
      [routerLink]="['/home']"
      class="mobile"
    />
    <h1>Política de privacidade</h1>
    <h2>
      Nós utilizamos os seus dados e os dados da sua loja como parte da nossa
      missão de proporcionar um serviço cada vez melhor. Essa Política de
      Privacidade descreve como obtemos, armazenamos, utilizamos e
      compartilhamos essas informações. A proteção dos seus dados e da sua
      privacidade é muito importante para o PESCAPREÇOS. Portanto, recomendamos que
      você conheça melhor as nossas práticas e, em caso de dúvidas, entre em
      contato conosco. Você consente, de forma livre e expressa, que seus dados
      e informações da sua loja sejam coletados, armazenados, tratados e
      compartilhados, conforme as regras dispostas nesta Política de
      Privacidade. Ao acessar a plataforma PESCAPREÇOS, você garante de forma
      expressa que é plenamente capaz, nos termos da legislação vigente, para
      exercer e gozar de todos os serviços. Informamos ainda a você que o
      serviço prestado pelo PESCAPREÇOS não é direcionado a menores de 18 anos.
    </h2>
    <div class="terms__content--policy">
      <section class="policy">
        <p><strong>Quais tipos de informações coletamos?</strong></p>
        <p>
          Ao utilizar o PESCAPREÇOS, nós coletamos algumas informações importantes
          para que possamos prestar um serviço adequado para você. Abaixo
          detalhamos quais são essas informações.
        </p>
        <p>
          Para acessar os serviços do PESCAPREÇOS você deverá ser uma LOJA PARCEIRA
          do PESCAPREÇOS e utilizar seu login e senha de acesso da plataforma de
          gerenciamento.
        </p>
        <p>
          Quando você se cadastra para ser uma LOJA PARCEIRA do PESCAPREÇOS,
          poderemos obter uma série de informações sobre você, tais como: nome
          empresarial, número de inscrição no CNPJ ou CPF, endereço eletrônico,
          endereço de correspondência, dados bancários, senha, número de
          telefone, preferências de contato e informações similares de
          titularidade dos seus representantes legais e/ou funcionários que
          tenham acesso ao PESCAPREÇOS (nome, número de inscrição no CPF, endereço
          eletrônico, número de telefone, entre outras). Tais informações
          cadastrais são fornecidas por você no momento da contratação dos
          serviços prestados pelo PESCAPREÇOS e o tratamento desses dados não é
          realizado pelo PESCAPREÇOS.
        </p>
        <p>
          Além dessas informações de login e senha, nós podemos coletar algumas
          informações automaticamente sobre os dispositivos a partir dos quais
          você acessa o PESCAPREÇOSDentre essas informações, estão endereços IP,
          tipo de navegador e idioma, provedor de serviços de Internet (ISP),
          páginas de consulta e saída, sistema operacional, informações sobre
          data e horário, dados sobre a sequência de cliques, fabricante do
          dispositivo, operadora, modelo, redes Wi-Fi, número de telefone, entre
          outras que poderão ser coletadas pelo PESCAPREÇOS.
        </p>
        <p>
          Nós também poderemos obter informações sobre suas atividades no
          Aplicativo PESCAPREÇOSEssas informações são agregadas, portanto
          anônimas, e usadas para nos ajudar a entender quais partes dos nossos
          produtos e serviços atraem mais interesse dos usuários. Dados
          agregados são considerados informações não-pessoais para fins desta
          Política.
        </p>
      </section>
      <section class="policy">
        <p><strong>Utilizamos suas informações para: </strong></p>
        <p>
          Promover, melhorar e desenvolver nossos serviços, podemos usar essas
          informações coletadas para nos ajudar a desenvolver, oferecer e
          melhorar os nossos produtos e serviços destinados a você, existentes
          ou serem criados.
        </p>
        <p>
          Também poderemos usar suas informações para fins internos, tais como
          auditoria, análise de dados e pesquisas para aprimorar os produtos,
          serviços e comunicações com as lojas parceiras, e geração de análises
          estatísticas com respeito ao uso dos nossos serviços.
        </p>
      </section>
      <section class="policy">
        <p><strong>Avaliação de lojas</strong></p>
        <p>
          Ao responder comentários das avaliações dos clientes PESCAPREÇOS, você
          nos autoriza a publicar e utilizar tais respostas nos sites ou nos
          Aplicativos do PESCAPREÇOS e em quaisquer materiais de marketing ou
          publicidade, bem como a analisar, processar e tratar essa resposta de
          forma isolada ou agregada nos termos desta Política. Para tanto,
          apenas identificamos você através do nome da sua loja.
        </p>
      </section>
      <section class="policy">
        <p><strong>Suporte</strong></p>
        <p>
          Ao enviar mensagens ao suporte do PESCAPREÇOS você garante que as
          informações, tais como o e-mail e o telefone informados, são da loja e
          não informações pessoais. Poderemos usar tais informações para
          responder sua mensagem e entrar em contato com você.
        </p>
      </section>
      <section class="policy">
        <p><strong>Comunicação</strong></p>
        <p>
          Periodicamente poderemos usar as suas informações para enviar avisos e
          notificações importantes, como comunicados sobre compras, alterações
          em prazos, condições e políticas. Como estas informações são
          importantes para a sua interação com o PESCAPREÇOS, você não poderá optar
          por não receber esse tipo de comunicação, já que são inerentes e
          essenciais ao uso do serviço.
        </p>
      </section>
      <section class="policy">
        <p><strong>Segurança e prevenção a fraude</strong></p>
        <p>
          Nós podemos também utilizar esses dados coletados para aprimorar a
          segurança e melhorar os serviços e as ofertas do PESCAPREÇOS destinadas a
          você. Dessa forma, podemos analisar e solucionar problemas técnicos,
          bem como identificar e coibir fraudes na utilização do nosso serviço.
        </p>
      </section>
      <section class="policy">
        <p><strong>Marketing</strong></p>
        <p>
          Nós poderemos usar suas informações e da sua loja para enviar
          publicidade, bem como outros materiais promocionais voltados ao
          marketing de nossos serviços e de novidades para você, o que inclui
          campanhas digitais (tais como marketing direcionado em redes sociais e
          notificações push) e não digitais (como divulgação em radiodifusão,
          outdoors, panfletos, entre outros).
        </p>
      </section>
      <section class="policy">
        <p><strong>Como e onde as informações são armazenadas? </strong></p>
        <p>
          As suas informações são armazenadas em serviços de nuvem confiáveis de
          parceiros que podem estar localizados no Brasil ou em outros países
          que ofereçam serviço de armazenamento de nuvem confiáveis e usualmente
          utilizados por empresas de tecnologia, tais como Estados Unidos da
          América (EUA) e em países da América Latina e da Europa. Na
          contratação desses serviços, o PESCAPREÇOS sempre busca empresas que
          empregam alto nível de segurança no armazenamento de suas informações,
          estabelecendo contratos que não violam as definições de privacidade
          previstas nessa Política.
        </p>
      </section>
      <section class="policy">
        <p><strong>Por quanto tempo as informações são armazenadas?</strong></p>
        <p>
          O PESCAPREÇOS armazena as suas informações durante o período necessário
          para as finalidades apresentadas nesta Política, respeitando o período
          de retenção de dados determinado pela legislação aplicável.
        </p>
      </section>
      <section class="policy">
        <p><strong>Como respondemos a requerimentos legais?</strong></p>
        <p>
          O PESCAPREÇOS também poderá compartilhar suas informações com autoridades
          policiais ou judiciais, autoridades públicas competentes ou outros
          terceiros, dentro e fora do país em que você reside, caso seja
          requerido pela legislação aplicável, por decisão judicial e por
          requisição de autoridades, ou se necessário para responder a processos
          judiciais ou para participar em eventuais litígios ou disputas de
          qualquer natureza.
        </p>
        <p>
          Nestas situações, o PESCAPREÇOS cooperará com as autoridades competentes
          na medida em que discricionariamente entenda necessário e adequado em
          relação a qualquer investigação de ilícitos, infrações a direitos de
          propriedade industrial ou intelectual, ou outra atividade que seja
          ilegal ou que possa expor o PESCAPREÇOS ou seus usuários a qualquer
          responsabilidade legal ou lhes impor riscos, ressalvadas hipóteses de
          sigilo de informações constantes na legislação aplicável.
        </p>
        <p>
          Além disso, o PESCAPREÇOS se reserva o direito de compartilhar
          informações sobre seus usuários a terceiros quando houver motivos
          suficientes para considerar que a atividade de um usuário é suspeita,
          ilegal ou prejudicial ao PESCAPREÇOS ou a terceiros. Este direito será
          utilizado pelo PESCAPREÇOS quando considerar apropriado ou necessário
          para manter a integridade e a segurança do seu serviço, para o
          cumprimento do seu contrato com o PESCAPREÇOS e para cumprimento desta
          Política, e com o intuito de cooperar com a execução e cumprimento da
          lei, independentemente de existir ou não uma ordem judicial ou
          administrativa para tanto.
        </p>
      </section>
      <section class="policy">
        <p><strong>Como protegemos suas informações?</strong></p>
        <p>
          O PESCAPREÇOS emprega seus melhores esforços para respeitar e proteger
          suas informações pessoais contra perda, roubo ou qualquer modalidade
          de uso indevido, bem como contra acesso não autorizado, divulgação,
          alteração e destruição.
        </p>
        <p>
          Utilizamos o princípio de privacy by design, respeitando a sua
          privacidade e protegendo seus dados nos nossos processos internos como
          um todo.
        </p>
        <p>
          Só tratamos os seus dados mediante alto grau de segurança,
          implementando as melhores práticas em uso na indústria para a proteção
          de dados, tais como técnicas de criptografia, monitoração e testes de
          segurança periódicos. Contudo, não é possível garantir completamente a
          não ocorrência de interceptações e violações dos sistemas e bases de
          dados do PESCAPREÇOS, uma vez que a internet possui sua estrutura de
          segurança em permanente aperfeiçoamento.
        </p>
      </section>
      <section class="policy">
        <p>
          <strong
            >Como iremos notificá-lo em caso de mudanças a essa
            Política?</strong
          >
        </p>
        <p>
          O PESCAPREÇOS poderá atualizar essa Política periodicamente, sendo que a
          versão em vigor será sempre a mais recente. Se fizermos alguma
          alteração na Política em termos materiais, podemos colocar um aviso
          nos nossos sites, Aplicativos, CENTRAL ADMINISTRATIVA ou te enviar um
          e-mail, juntamente com a Política atualizada. Por isso é sempre
          importante manter seus dados de contato atualizados. Para verificar a
          data da versão em vigor, verifique a “Data de atualização” no final
          desse documento.
        </p>
      </section>
      <section class="policy">
        <p>
          <strong
            >Como entrar em contato com PESCAPREÇOS em caso de dúvidas?</strong
          >
        </p>
        <p>
          Se você tiver algum questionamento ou dúvida com relação à Política de
          Privacidade do PESCAPREÇOS ou qualquer prática aqui descrita, entre em
          contato conosco através da nossa página de suporte na Plataforma ou
          pelo e-mail:
          <!-- <a href="mailto:PESCAPREÇOS&#64;PESCAPREÇOS.com.br" target="_blank"
            >PESCAPREÇOS&#64;PESCAPREÇOS.com.br</a
          >
          ou -->
          <a href="mailto:PESCAPREÇOS&#64;gmail.com" target="_blank"
            >pescaprecos&#64;gmail.com</a
          >.
        </p>
      </section>
    </div>
  </div>
  <app-footer class="footer"></app-footer>
</div>
